import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Container,
  Grid,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from "./FAQ.module.css";
import { Helmet } from "react-helmet";

const FAQ = () => {
  const faqData = [
    {
      question: "What is AI Face Wrap?",
      answer:
        "AI Face Wrap is a cutting-edge technology that uses artificial intelligence to apply realistic wraps, masks, or transformations to faces in images or videos. It can be used for creative editing, special effects, or personalization.",
    },
    {
      question: "What kind of face transformations can I create?",
      answer:
        "You can create a wide range of transformations, including applying virtual makeup, aging or de-aging effects, face swaps, artistic filters, and even turning your face into a cartoon or fantasy character.",
    },
    {
      question: "How accurate is the AI Face Wrap technology?",
      answer:
        "Our AI is highly accurate and uses advanced facial recognition algorithms to ensure seamless and realistic transformations. It adapts to different face shapes, skin tones, and lighting conditions for optimal results.",
    },
    {
      question: "Can I use AI Face Wrap for professional projects?",
      answer:
        "Yes, AI Face Wrap is suitable for both personal and professional use. It can be used in photography, video production, social media content creation, and more. All outputs are royalty-free for commercial use.",
    },
    {
      question: "What file formats are supported for input and output?",
      answer:
        "We support common image formats like JPEG, PNG, and WEBP for input. Outputs can be downloaded in high-resolution formats, including PNG and JPEG, with resolutions up to 4K.",
    },
    {
      question: "How long does it take to process a face wrap?",
      answer:
        "Processing time typically ranges from 3 to 15 seconds, depending on the complexity of the transformation and the quality of the input image or video.",
    },
    {
      question: "Is my data safe when using AI Face Wrap?",
      answer:
        "Yes, we prioritize user privacy and data security. Uploaded images are processed securely and are not stored on our servers after the transformation is complete.",
    },
    {
      question: "Can I customize the face wrap effects?",
      answer:
        "Absolutely! Our platform allows you to adjust various parameters like intensity, color, and style to create fully customized face wraps that match your vision.",
    },
    {
      question: "Does AI Face Wrap work on group photos?",
      answer:
        "Yes, the AI can process multiple faces in a single image, allowing you to apply transformations to each individual face in group photos.",
    },
    {
      question: "What devices are supported?",
      answer:
        "AI Face Wrap is compatible with most devices, including smartphones, tablets, and computers. It works seamlessly on both web browsers and mobile apps.",
    },
  ];

  // Create schema markup for FAQ
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqData.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };

  return (
    <Container maxWidth="lg" className={styles.container}>
      <Helmet>
        {/* Structured Data */}
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>
      <Typography variant="h2" className={styles.heading}>
        Frequently Asked Questions
      </Typography>
      <Typography variant="h6" className={styles.subheading}>
        Can't find the answer you're looking for? Reach out to our customer
        support team
      </Typography>

      <Grid item xs={12} md={8}>
        {faqData.map((faq, index) => (
          <Accordion key={index} className={styles.accordion}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon className={styles.expandIcon} />}
              aria-controls={`panel${index}-content`}
              id={`panel${index}-header`}
            >
              <Typography className={styles.question}>
                {faq.question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className={styles.answer}>{faq.answer}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Grid>
    </Container>
  );
};

export default FAQ;
